import { Helmet } from "react-helmet-async";

const SITE_URL = "https://iambecause.com";
const DEFAULT_TITLE = "iambecause — Why do you do what you do?";
const DEFAULT_DESC = "A collection of real human stories. Everyone has a reason. A moment that changed everything. This is a place to share yours. No ads. No algorithms. Just why.";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

export const Seo = ({ title, description, path = "", image, type = "website", noindex = false, jsonLd = null }) => {
  const fullTitle = title ? `${title} — iambecause` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content="iambecause" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

const ROUTE_META = {
  "/": { title: null, description: DEFAULT_DESC },
  "/submit": { title: "Share your story", description: "Tell the world why you do what you do. Share the moment that changed everything — in your own words, at your own pace." },
  "/about": { title: "About", description: "iambecause is a home for the question behind every life: why do you do what you do? Real stories, told by real people." },
  "/insights": { title: "Insights", description: "Patterns and reflections drawn from the stories people share about why they do what they do." },
  "/mirror": { title: "The Mirror", description: "A private, once-a-year conversation with yourself. Guided by Mira. Seen by no one but you." },
  "/icons": { title: "Icons of India", description: "The visionaries who transformed India into a global powerhouse. In each film, Sam Pitroda sits down with an icon to document the moments that shaped a nation." },
  "/conversations": { title: "Conversations — Icons of India", description: "Fireside chats with the nation-builders of modern India. Sam Pitroda in conversation with 21 icons — watch the full films." },
  "/because": { title: "Because", description: "From Icons of India to iambecause — every great life begins with a reason. Explore the bridge between legacy and purpose." },
  "/privacy": { title: "Privacy Policy" },
  "/terms": { title: "Terms of Use" },
  "/guidelines": { title: "Community Guidelines" },
};

export const RouteSeo = ({ pathname }) => {
  if (pathname.startsWith("/admin")) return <Seo title="Admin" noindex path={pathname} />;
  if (pathname.match(/^\/mirror\/.+/)) return <Seo title="The Mirror" noindex path="/mirror" />;
  const meta = ROUTE_META[pathname];
  if (!meta) return null;
  return <Seo title={meta.title} description={meta.description} path={pathname === "/" ? "" : pathname} />;
};
